if (!customElements.get('card-scrub')) {
  class CardScrub extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.card-scrub__media');
      this.slides = [...this.querySelectorAll('.card-scrub__slide')];
      this.segs = [...this.querySelectorAll('.card-scrub__seg')];
      this.swatches = [...this.querySelectorAll('.card-scrub__swatch')];
      this.models = [...new Set(this.slides.map((s) => s.dataset.model))];
      this.color = this.dataset.color;
      this.model = this.dataset.model;

      // Desktop: hover position picks the model
      this.media.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const r = this.media.getBoundingClientRect();
        const i = Math.min(
          this.models.length - 1,
          Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * this.models.length))
        );
        this.model = this.models[i];
        this.render();
      });
      this.media.addEventListener('pointerleave', () => {
        this.model = this.dataset.model;
        this.render();
      });

      // Touch: swipe to step through models
      let startX = 0;
      this.media.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.media.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 30) return;
        const i = this.models.indexOf(this.model) + (dx < 0 ? 1 : -1);
        this.model = this.models[(i + this.models.length) % this.models.length];
        this.render();
      });

      this.swatches.forEach((btn) =>
        btn.addEventListener('click', () => {
          this.color = btn.dataset.color;
          this.render();
        })
      );

      this.render();
    }

    render() {
      this.slides.forEach((s) => {
        s.classList.toggle('is-active', s.dataset.model === this.model && s.dataset.color === this.color);
      });
      const idx = this.models.indexOf(this.model);
      this.segs.forEach((seg, i) => seg.classList.toggle('is-active', i === idx));
      this.swatches.forEach((b) => b.classList.toggle('is-selected', b.dataset.color === this.color));
    }
  }
  customElements.define('card-scrub', CardScrub);
}